import getServiceLocation from '@/lib/getServiceLocation';
import { getAuthenticatedFetchJSON } from './fetch';

const fetchTranslation = (injectedFetch = fetch, location = getServiceLocation('translation')) => {
    const configuredFetch = getAuthenticatedFetchJSON(injectedFetch);

    return configuredFetch(location);
};

export default fetchTranslation;
